<template>
	<div class="inputFieldContainer">
		<label
			:for="id"
			v-if="label"
			class="inputFieldLabel"
			:class="labelColor"
			>{{ label }}
			<FormRequiredAsterisk :required="required" />
			<FormTooltip
				v-if="!!tooltipMsg"
				:id="id + `-tooltip`"
				:tooltip-msg="tooltipMsg" />
		</label>

		<div class="relative">
			<input
				:id="id"
				:autocomplete="autocomplete"
				type="text"
				:placeholder="placeholder"
				v-model="value"
				@input="emitEvent('input')"
				class="inputField text-sm pr-28" />

			<div class="absolute top-1 right-1">
				<ButtonSecondary
					class="text-xs h-8 font-normal"
					:disabled="disabled"
					@clicked="emitEvent('clicked')"
					>{{ btnLabel }}</ButtonSecondary
				>
			</div>
		</div>
	</div>
</template>

<script setup>
	const runtimeConfig = useRuntimeConfig()

	const { id, initialValue, disableAutocomplete } = defineProps({
		id: {
			type: String,
			default: "inputField",
		},
		label: {
			type: String,
		},
		labelColor: {
			type: String,
			default: "text-primary",
		},
		placeholder: {
			type: String,
			default: "",
		},
		btnLabel: {
			type: String,
		},
		required: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		initialValue: {
			type: String,
			default: "",
		},
		tooltipMsg: {
			type: String,
			default: "",
		},
		disableAutocomplete: {
			type: Boolean,
			default: false,
		},
	})

	const autocomplete = disableAutocomplete || runtimeConfig.public.IS_KIOSK_APP ? "dsadsa" : ""

	const emits = defineEmits(["input", "clicked"])
	const value = ref(initialValue)
	const emitEvent = (eventName) => {
		emits(eventName, { id: id, value: value.value })
	}
</script>

<style scoped></style>
